export default function({ state, commit, dispatch, rootState }, { provider, patient, documentIdObj}) {
    return dispatch('post', {
        url: '/provider/' + provider + '/patient/' + patient + '/send_document_to_emr',
        data: { document_ids: documentIdObj.document_id }
    }, {
        root: true
    })
}
